import _ from 'lodash';

import { ERROR_PAGES_PATH_PREFIX } from 'constants/navigation';
import { IS_TEST_MODE } from 'constants/test';
import { getIsAbsoluteExternalUrl, openExternalUrl } from 'utils/nativeFile';
import { getIsNativePlatform } from 'utils/platform';

export const checkIsErrorPagePath = pathname => _.startsWith(pathname, ERROR_PAGES_PATH_PREFIX);

export const openURLInNewTab = (url, shouldFocusTab = true) => {
  if (getIsNativePlatform() && getIsAbsoluteExternalUrl(url)) {
    return openExternalUrl(url);
  }

  const tab = window.open(url, IS_TEST_MODE ? '_self' : '_blank');

  if (shouldFocusTab) {
    tab?.focus();
  }

  return tab;
};

export const openURLInCurrentTab = url => {
  if (getIsNativePlatform() && getIsAbsoluteExternalUrl(url)) {
    return openExternalUrl(url);
  }

  return window.open(url, '_self');
};
